import BookingPartnerLogo from "@/components/yts/BookingPartnerLogo";

/** Display the uploaded Viator wordmark on every Viator experience card. */
export default function ViatorBadge({ label = "Book on Viator", className = "" }) {
  return (
    <span role="img" aria-label={label} title={label} className={`inline-flex min-h-[25px] items-center ${className}`}>
      <BookingPartnerLogo provider="viator" className="!h-[24px]" />
    </span>
  );
}
